<template>
	<div id="addAddr">
		<div class="right">
			<el-button type="primary" icon="el-icon-plus" @click="newAdd">增加地址</el-button>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" height='calc(100vh - 300px)'>
				<el-table-column prop="name" label="收件人">
				</el-table-column>
				<el-table-column label="联系电话" prop="contractNo"></el-table-column>
				<el-table-column label="收件地址" prop="address"></el-table-column>
				<el-table-column prop="postcode" label="邮政编码">
				</el-table-column>
				<el-table-column label="操作">
					<template slot-scope='scope'>
						<el-button type="text" @click='updataFun(scope.row)'>修改</el-button>
						<el-button type="text" @click='centerDialogVisible1=true;deleteId=scope.row.id'>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="500" center>
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="收件人姓名:" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="收件人电话" prop="contractNo">
					<el-input v-model.number="ruleForm.contractNo"></el-input>
				</el-form-item>
				<el-form-item label="收件人地址" prop="address">
					<el-input v-model="ruleForm.address"></el-input>
				</el-form-item>
				<el-form-item label="收件地邮编" prop="postcode">
					<el-input v-model="ruleForm.postcode"></el-input>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false;getData()">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="确认删除？" :visible.sync="centerDialogVisible1" width="600px" center>
			<span>删除后不可恢复，是否确认删除？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible1 = false">取 消</el-button>
				<el-button type="primary" @click="deleteFun">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		updateAddress,
		addressList,
		deleteAddress
	} from '@/axios/api.js'
	export default {
		data() {
			var name = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入联系人姓名'));
				} else {
					callback();
				}
			};
			var address = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入联系地址'));
				} else {
					callback();
				}
			};
			var postcode = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入邮政编码'));
				} else {
					callback();
				}
			};
			var contractNo = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('手机号不能为空'));
				}
				if (!Number.isInteger(value)) {
					callback(new Error('请输入数字值'));
				} else {
					callback();
				}
			};
			return {
				tableData: [],
				centerDialogVisible: false,
				centerDialogVisible1: false,
				ruleForm: {
					id: '',
					name: '',
					contractNo: '',
					address: '',
					postcode: ''
				},
				rules: {
					name: [{
						validator: name,
						trigger: 'blur'
					}],
					contractNo: [{
						validator: contractNo,
						trigger: 'blur'
					}],
					address: [{
						validator: address,
						trigger: 'blur'
					}],
					postcode: [{
						validator: postcode,
						trigger: 'blur'
					}],
				},
				title: '新增地址',
				deleteId: ''
			}
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.postData()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			postData() {
				updateAddress(this.ruleForm)
					.then(res => {
						console.log(res);
						var message = ''
						if (res.data.code == 0) {
							if (this.title == '新增地址') {
								message = '新增地址成功'
							} else {
								message = '修改地址成功'
							}
							this.$message({
								showClose: true,
								message,
								type: 'success'
							});
							this.getData();
							this.centerDialogVisible = false;
							this.resetForm('ruleForm')
						}
					})
					.catch(err => {
						console.log(err);
					})
			},
			getData() {
				addressList()
					.then(res => {
						console.log(res);
						this.tableData = res.data.obj
					})
					.catch(err => {
						console.log(err);
					})
			},
			updataFun(data) {
				this.title = '修改地址';
				data.contractNo = Number(data.contractNo)
				this.ruleForm = data;
				this.centerDialogVisible = true;
			},
			newAdd() {
				this.centerDialogVisible = true;
				this.title = '新增地址';
				this.ruleForm = {
					id: '',
					name: '',
					contractNo: '',
					address: '',
					postcode: ''
				}
			},
			deleteFun(){
				var data={
				    addressId:this.deleteId
				}
				deleteAddress(data)
				.then( res => {
				    console.log(res);
						if(res.data.code == 0){
							this.$message({
								type:'success',
								message:'删除成功！'
							})
							this.centerDialogVisible1=false;
							this.getData()
						}
				})
				.catch(err => {
				    console.log(err);
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style scoped>
	.right {
		text-align: right;
	}

	.table {
		margin-top: 20px;
	}

	#addAddr {
		background: white;
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/card/addrAdd.vue